<div class="snackBarContainer" fxFlex fxLayout="column" fxLayoutGap="16px">
    <h5 class="white">
        {{ 'GENERIC.SNACKBAR.NEW.CUSTOMER-SAVED' | translate }} 
    </h5>
    <div fxFlex fxLayout="row" fxLayoutGap="16px">
        <button  class="btn btn-primary" type="button" (click)="navigateToNewCustomer()">{{ 'GENERIC.SNACKBAR.ORDER.GO.TO.NEW.CUSTOMER' | translate }} </button>
        <button  class="btn btn-secondary border" type="button" (click)="Dismiss()">{{ 'BTN.CLOSE' | translate }}</button>

    </div>
</div>